import "./App.css";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header/Header";
import { Switch, Route } from "react-router-dom";
import { SecureRoute } from "@okta/okta-react";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Home from "./pages/Home";
import GroundingPage from "./pages/GroundPending/grouded-vehicle-list";
import PurchasedVehicleList from "./pages/GroundPending/purchased-vehicle-list";
import PassedVehicleList from "./pages/GroundPending/passed-vehicle-list";
import { LastChance } from "./pages/Grounded";
import "../src/assets/WebFont/ToyotaType-Book.ttf";
import "../src/sass/main.scss";
import VINSearch from "./pages/GroundPending/VINSearch";
import ConditionReport from "./pages/ConditionReport";
import AdminHome from "./pages/AdminHome";
import AdminDetailedReport from "./pages/AdminDetailedReport";
import AdminVehicleSearch from "./components/AdminVehicleSearch";
import AdminVehicleSearchUnground from "./components/AdminVehicleSearchUnground";
import ConditionReportRequests from "./pages/ConditionReportRequests";
import InventoryRequestsTabs from "./components/InventoryRequestsTabs";
import Login2 from "./pages/Login2";
import Login3 from "./pages/Login3";
import Login from "./components/Login";
import SessionExpired from './components/SessionExpired';
import withNetworkHandler from './withNetworkHandler';
import axios from './service/api';
import { useIdleTimer } from 'react-idle-timer';
import FileUpload from './components/file-upload/FileUpload';
import BusinessAdminComponent from './components/Business-Admin-Component/BusinessAdminComponent';
import SystemAdminComponent from './components/System-Admin-Component/SystemAdminComponent';
import ArbitrationComponent from './components/Arbitration-Component/ArbitrationComponent';
import ArbitrationReviewpage from './pages/ArbitrationReviewPage';
import NotAuthorized from "./pages/NotAuthorizedPage";
import VehicleHistory from "./pages/VehicleHistory";

const Layout = () => {
    const history = useHistory();
    const [stateUpdate, setStateUpdate] = useState(1);
    const [selectedDealersData, setSelectedDealersData] = useState([]);
    const [userRole, setUserRole] = useState('');
    const [, setParentNavUpdate] = React.useState('');
    const [isSessionTimedOut, setIsSessionTimedOut] = useState(false);
    let pageData = null;
    const fireEvents = () => {
        setStateUpdate(stateUpdate + 1);
    };
    const userRoleUpdated = (data) => {
        setUserRole(data);
    }
    const selectedDealers = (data) => {
        setSelectedDealersData(data);
    };
    const handleOnIdle = () => {
        setIsSessionTimedOut(true);
        localStorage.clear();
        sessionStorage.clear();
        history.push('/sessionexpired');
    }
    useIdleTimer({
        timeout: 1000 * 60 * 60,
        onIdle: handleOnIdle,
        debounce: 500
    });
    if(history.location.pathname && history.location.pathname.split('/')?.length > 2 && history.location.pathname.indexOf('login') < 0) {
        const data = history.location.pathname.split('/');
        const arbitrationJsonObect = atob(data[data?.length - 1]);
        pageData = JSON.parse(arbitrationJsonObect);
    }
    return (
        <div>
            <div>
                {
                    !isSessionTimedOut ?
                        <div>
                            <Header selectedDealers={selectedDealers} history={history} displayHeaderControls={true}></Header>
                            <div>
                                <Sidebar setParentNavUpdate={setParentNavUpdate} selectedDealersData={selectedDealersData} userRole={userRole}>
                                    <Switch>
                                    <SecureRoute
                                            path="/"
                                            exact
                                            render={(props) => <Login {...props} />}
                                        />
                                        <Route
                                            path="/home"
                                            exact
                                            render={(props) => <Home {...props} selectedDealersData={selectedDealersData} />}
                                        />
                                        <Route
                                            path="/businessAdmin"
                                            exact
                                            component={BusinessAdminComponent}
                                        />
                                         <Route
                                            path="/systemAdmin"
                                            exact
                                            component={SystemAdminComponent}
                                        />
                                        <Route
                                            path="/adminSearch"
                                            exact
                                            component={AdminVehicleSearch}
                                        />
                                        <Route
                                            path="/unground"
                                            exact
                                            component={AdminVehicleSearchUnground}
                                        />
                                        <Route
                                            path="/adminSearchResult"
                                            exact
                                            component={AdminHome}
                                            forceRefresh={true}
                                        />
                                        <Route
                                            path="/groundingHistory"
                                            exact
                                            component={VehicleHistory}
                                            forceRefresh={true}
                                        />
                                        <Route path="/checkinvehicle" exact component={VINSearch} />
                                        <Route
                                            path="/grounded"
                                            exact
                                            render={(props) => (
                                                <GroundingPage
                                                    {...props}
                                                    fireEvents={fireEvents}
                                                    selectedDealersData={selectedDealersData}
                                                />
                                            )}
                                        />
                                        <Route
                                            path="/passed"
                                            exact
                                            render={(props) => <PassedVehicleList {...props}
                                                selectedDealersData={selectedDealersData}
                                            />}
                                        />
                                        <Route
                                            path="/purchased"
                                            exact
                                            render={(props) => <PurchasedVehicleList {...props}
                                                selectedDealersData={selectedDealersData}
                                            />}
                                        />
                                        <Route
                                            path="/grounded/lastchance"
                                            exact
                                            component={LastChance}
                                        />

                                        <Route
                                            path="/adminInventoryRequests"
                                            exact
                                            component={InventoryRequestsTabs}
                                        />

                                        <Route
                                            path="/conditionreportRequests"
                                            render={(props) => <ConditionReportRequests {...props} selectedDealersData={selectedDealersData}  pageData={pageData} />}
                                        />
                                        <Route
                                            path="/conditionreport/:vin"
                                            exact
                                            render={(props) => <ConditionReport {...props} selectedDealersData={selectedDealersData} />}
                                        />
                                        <Route
                                            path="/conditionreport"
                                            exact
                                            render={(props) => <ConditionReport {...props} selectedDealersData={selectedDealersData} />}
                                        />
                                        <Route
                                            path="/login2"
                                            exact
                                            render={(props) => (
                                                <Login2 {...props} fireEvents={fireEvents} />
                                            )}
                                        />
                                        <Route
                                            path="/login3"
                                            exact
                                            render={(props) => (
                                                <Login3 {...props} fireEvents={fireEvents} userRoleUpdate={userRoleUpdated} />
                                            )}
                                        />
                                        <SecureRoute
                                            path="/login"
                                            exact
                                            render={(props) => <Login {...props} />}
                                        />
                                        <Route
                                            path="/sessionexpired"
                                            exact
                                            component={SessionExpired}
                                        />
                                        <Route
                                            path="/fileUpload"
                                            exact
                                            component={FileUpload}
                                        />
                                        <Route
                                            path="/arbitration"
                                            exact
                                            component={ArbitrationComponent}
                                        />
                                        <Route
                                            path="/arbitrationReview"
                                            exact
                                            render={(props) => <ArbitrationReviewpage {...props} />}
                                        />
                                         <Route
                                            path="/notAuthorized"
                                            exact
                                            component={NotAuthorized}
                                        />
                                    </Switch>
                                </Sidebar>
                            </div>
                            <Route
                                path="/sessionexpired"
                                exact
                                component={SessionExpired}
                            />
                        </div> : ''
                }
                <Route
                    path="/sessionexpired"
                    exact
                    component={SessionExpired}
                />
            </div>
        </div>
    )
}

export default withNetworkHandler(Layout, axios);
